var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgScaleIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2322_141",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 30,
    height: 30
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2322_141)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.2869 20.6859H23.1956V15.7469H22.1378V19.6281H18.2869V20.6859ZM6.80937 14.2531H7.86688V10.3719H11.7178V9.31406H6.80937V14.2531ZM5.57688 23.75C5.06479 23.75 4.63229 23.5735 4.27938 23.2206C3.92646 22.8677 3.75 22.4352 3.75 21.9231V8.07688C3.75 7.56479 3.92646 7.13229 4.27938 6.77938C4.63229 6.42646 5.06479 6.25 5.57688 6.25H24.4231C24.9352 6.25 25.3677 6.42646 25.7206 6.77938C26.0735 7.13229 26.25 7.56479 26.25 8.07688V21.9231C26.25 22.4352 26.0735 22.8677 25.7206 23.2206C25.3677 23.5735 24.9352 23.75 24.4231 23.75H5.57688ZM5.57688 22.6922H24.4231C24.6154 22.6922 24.7917 22.6121 24.9519 22.4519C25.1121 22.2917 25.1922 22.1154 25.1922 21.9231V8.07688C25.1922 7.88458 25.1121 7.70833 24.9519 7.54812C24.7917 7.38792 24.6154 7.30781 24.4231 7.30781H5.57688C5.38458 7.30781 5.20833 7.38792 5.04812 7.54812C4.88792 7.70833 4.80781 7.88458 4.80781 8.07688V21.9231C4.80781 22.1154 4.88792 22.2917 5.04812 22.4519C5.20833 22.6121 5.38458 22.6922 5.57688 22.6922Z",
    fill: "#404040"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScaleIcon);
export default __webpack_public_path__ + "static/media/scale-icon.3a384ce87c1293c89d53c6cc10563e7d.svg";
export { ForwardRef as ReactComponent };